const common = {
  'common.loading': 'Yükleniyor...',
  'common.error': 'Bir hata oluştu',
  'common.success': 'Başarılı!',
  'common.cancel': 'İptal',
  'common.confirm': 'Onayla',
  'common.submit': 'Gönder',
  'common.save': 'Kaydet',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.add': 'Ekle',
  'common.remove': 'Kaldır',
  'common.continue': 'Devam Et',
  'common.back': 'Geri',
  'common.next': 'İleri',
  'common.previous': 'Önceki',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.search': 'Ara',
  'common.filter': 'Filtrele',
  'common.sort': 'Sırala',
  'common.noResults': 'Sayfa bulunamadı',
  'common.selectOne': 'Birini seçin',
  'common.required': 'Zorunlu',
  'common.optional': 'İsteğe bağlı',
  'common.learnMore': 'Daha Fazla Bilgi',
  'common.getStarted': 'Başlayın',
  'common.signUp': 'Kayıt Ol',
  'common.signIn': 'Giriş Yap',
  'common.dark': 'Koyu',
  'common.light': 'Açık',
  'common.system': 'Sistem',
  'common.followTheme': 'Sistem temasını takip et',
  'common.language': 'Dil',
  'common.viewMore': 'Daha Fazla',
  'common.viewLess': 'Daha Az',
  'common.home': 'Ana Sayfa',
  'common.terms': 'Kullanım Koşulları',
  'common.privacy': 'Gizlilik Politikası',
  'common.cookies': 'Çerez Politikası',
  'common.contact': 'Bize Ulaşın',
  'common.contactMe': 'Bana Ulaşın',
  'common.profile': 'Profil',
  'common.settings': 'Ayarlar',
  'common.account': 'Hesap',
  'common.dashboard': 'Kontrol Paneli',
  'common.theme.light': 'Açık Tema',
  'common.theme.dark': 'Koyu Tema',
  'Member Since': 'Üyelik Başlangıcı',
  'profileNotFound': 'Profil bulunamadı',
  'common.documentation': 'API Dokümantasyonu',
  
  // Navigation items
  'nav.home': 'Ana Sayfa',
  'nav.news': 'Haberler',
  'nav.join': 'The Club\'a Katıl',
  'nav.tutorials': 'Eğitimler',
  'nav.strategies': 'Stratejiler',
  'nav.radex': 'Radex Markets',
  
  // News page translations
  'news.title': 'Son Haberler',
  'news.description': 'En son makaleler ve duyurularımızdan haberdar olun',
  'news.filterByTag': 'Etikete göre filtrele',
  'news.allPosts': 'Tüm Yazılar',
  'news.noPostsFound': 'Yazı bulunamadı',
  'news.viewAllPosts': 'Tüm yazıları görüntüle',
  'news.backToNews': 'Haberlere Dön',
  'news.relatedPosts': 'İlgili Yazılar',
  'news.sharePost': 'Bu yazıyı paylaş',
  'news.postNotFound': 'Yazı bulunamadı',
  'news.pagination.previous': 'Önceki',
  'news.pagination.next': 'Sonraki',
  
  // Social media links
  'social.instagram': 'https://www.instagram.com/theclub.finance/',
  'social.tiktok': 'https://www.tiktok.com/@the.club.fund',
  'social.youtube': 'https://www.youtube.com/@TheClub.finance',
  'social.facebook': 'https://www.facebook.com/profile.php?id=61576120443819',
  'social.telegram': 'https://t.me/theclubfund',
  
  // Footer translations
  'footer.company.description': 'The Club, servetinizi büyütmenize ve finansal özgürlüğe ulaşmanıza yardımcı olmak için tasarlanmış yenilikçi finansal ürünler ve hizmetler sunar.',
  'footer.theclub': 'The Club',
  'footer.conditions': 'Şartlar ve koşullar',
  'footer.customersupport': 'Müşteri Desteği',
  'footer.contactuswhatsapp': 'WhatsApp',
  'footer.radex': 'Radex Markets',
  'footer.rights': 'Tüm hakları saklıdır.',
  'footer.terms': 'Şartlar',
  'footer.privacy': 'Gizlilik',
  'footer.cookies': 'Çerezler',
  'footer.contactUs': 'Bize Ulaşın',
  'footer.contactMe': 'Bana Ulaşın',
  
  // Radex Markets translations
  'radex.hero.title': 'The Club & Radex Markets Ortaklığı',
  'radex.hero.subtitle': 'Stratejik ortaklığımız aracılığıyla olağanüstü trading fırsatlarını keşfedin',
  'radex.hero.learnMore': 'Daha Fazla Bilgi',
  'radex.hero.visitWebsite': 'Web Sitesini Ziyaret Et',
  'radex.hero.partnership': 'Özel Yatırım Fırsatları',
  'radex.hero.benefit1': 'Lisanslı ve Düzenlenmiş Broker',
  'radex.hero.benefit2': 'Son Teknoloji Trading Platformu',
  'radex.hero.benefit3': 'Gelişmiş Güvenlik Protokolleri',
  'radex.hero.benefit4': 'Özel Club Üye Avantajları',
  
  'radex.about.title': 'Radex Markets Hakkında',
  'radex.about.subtitle': 'Güvenlik, şeffaflık ve son teknoloji trading platformuna bağlı düzenlenmiş bir broker',
  'radex.about.establishmentTitle': 'Köklü Varlık',
  'radex.about.establishmentText': 'RADEX MARKETS 2019 yılında kurulmuş olup merkezi Seyşeller Cumhuriyeti\'ndedir. GO Markets International Ltd ticari unvanı altında faaliyet gösteren, Seyşeller Cumhuriyeti\'nde 8425985-1 tescil numarasıyla kurulmuş bir şirkettir.',
  'radex.about.regulationTitle': 'Lisanslı ve Düzenlenmiş',
  'radex.about.regulationText': 'Firma, güvenli ve uyumlu bir trading ortamı sağlayarak, Seyşeller Finansal Hizmetler Otoritesi (FSA) tarafından SD043 numaralı Menkul Kıymetler Satıcısı Lisansı kapsamında lisanslanmış ve düzenlenmiştir.',
  'radex.about.technologyTitle': 'Gelişmiş Teknoloji',
  'radex.about.technologyText': 'Radex Markets, güvenilir işlem gerçekleştirme ve profesyonel araçlarla modern yatırımcıların ihtiyaçlarını karşılamak üzere tasarlanmış son teknoloji ve rekabetçi bir trading ortamı sunar.',
  'radex.about.transparencyTitle': 'Şeffaflık ve Güven',
  'radex.about.transparencyText': 'Şeffaflık, Radex\'in temel değerlerinden biridir ve açık, dürüst ve çok dilli iletişimle gösterilmektedir. Bütünlüğüyle tanınan Radex Markets, güvenilirlik arayan yatırımcılar için güvenli ve güvenilir bir platform olarak öne çıkmaktadır.',
  
  'radex.features.title': 'Neden Radex Markets\'ı tercih ettik?',
  'radex.features.subtitle': 'Mükemmelliğe bağlı bir broker ile trading yapmanın avantajlarını deneyimleyin',
  'radex.features.security': 'Müşteri Koruması',
  'radex.features.securityText': 'Müşteri fonlarını ve kişisel verileri korumak için güçlü güvenlik protokolleri, güvenli bir trading ortamı sağlar.',
  'radex.features.technology': 'Son Teknoloji Platform',
  'radex.features.technologyText': 'Her seviyedeki yatırımcılar için güvenilir işlem gerçekleştirme ve profesyonel araçlarla gelişmiş trading teknolojisi.',
  'radex.features.transparency': 'Tam Şeffaflık',
  'radex.features.transparencyText': 'Açık, dürüst iletişim ve güvenilir işlem gerçekleştirme, en yüksek şeffaflık standartlarını korumaktadır.',
  'radex.features.global': 'Küresel Erişim',
  'radex.features.globalText': 'Çeşitli bölgelerden ve geçmişlerden yatırımcılara hizmet veren çok dilli destek ve hizmetler.',
  
  'radex.partnership.title': 'The Club & Radex Markets Ortaklığı',
  'radex.partnership.description': 'Radex Markets ile stratejik ortaklığımız, uzmanlığımızı düzenlenmiş ve güvenilir bir broker ile birleştirerek club üyelerimize benzersiz yatırım fırsatları sunmamızı sağlar.',
  'radex.partnership.details': 'Bu işbirliği sayesinde, The Club üyeleri özel trading koşullarına, gelişmiş hesap yönetimine ve her iki kuruluştan özel desteğe erişim kazanır. Radex Markets ve The Club ortaklığı, topluluğumuza olağanüstü değer sunma konusundaki ortak şeffaflık, güvenlik değerleri üzerine kurulmuştur.',
  'radex.partnership.contactUs': 'Detaylar İçin İletişime Geçin',
  'radex.partnership.visitRadex': 'Radex Markets\'ı Ziyaret Et',
  'radex.partnership.benefitsTitle': 'Ortaklık Avantajları',
  'radex.partnership.benefit1Title': 'Gelişmiş Güvenlik',
  'radex.partnership.benefit1Text': 'Fonlarınızın Radex Markets\'ın güçlü güvenlik protokolleriyle korunduğunu bilerek güvenle trading yapın.',
  'radex.partnership.benefit2Title': 'Özel Ürünler',
  'radex.partnership.benefit2Text': 'Yalnızca Club üyelerine sunulan özel yatırım ürünlerine ve trading koşullarına erişin.',
  'radex.partnership.benefit3Title': 'Profesyonel Destek',
  'radex.partnership.benefit3Text': 'Gelişmiş bir trading deneyimi için hem The Club hem de Radex Markets ekiplerinden özel yardım alın.',
    
  // Documentation translations
  'docs.title': 'API Dokümantasyonu',
  'docs.introduction': 'Giriş',
  'docs.introDescription': 'Bu uygulama, Supabase\'deki pg_graphql uzantısıyla desteklenen esnek bir veri erişim katmanı olarak GraphQL kullanır.',
  'docs.benefits': 'Bu yaklaşımın faydaları:',
  'docs.benefitDecoupling': 'Frontend\'i doğrudan veritabanı erişiminden ayırma',
  'docs.benefitTypeSafety': 'Uygulama genelinde güçlü tip güvenliği',
  'docs.benefitFlexibility': 'Minimum değişiklikle backend uygulamalarını değiştirme esnekliği',
  'docs.architecture': 'Mimari Genel Bakış',
  'docs.architectureDescription': 'Uygulama, sorumlulukları ayıran ve esneklik sağlayan katmanlı bir mimari kullanır:',
  'docs.serviceLayer': 'Servis Soyutlama Katmanı',
  'docs.serviceLayerDescription': 'Servis katmanı, temel uygulamadan bağımsız olarak tutarlı bir arayüz sağlar, uygulamanın doğrudan Supabase çağrıları ile GraphQL sorguları arasında uygulama kodunu değiştirmeden geçiş yapmasına olanak tanır.',
  'docs.schema': 'GraphQL Şeması',
  'docs.schemaDescription': 'GraphQL şeması, pg_graphql tarafından veritabanı yapısından otomatik olarak oluşturulur, belirli ihtiyaçlar için bazı ek özel çözümleyicilerle birlikte:',
  'docs.implementationGuide': 'Uygulama Kılavuzu',
  'docs.frontendImplementation': 'Frontend Uygulaması',
  'docs.frontendImplementationDescription': 'Frontend\'den GraphQL API ile etkileşim kurmak için Apollo Client kullanın:',
  'docs.serviceFactory': 'Servis Factory',
  'docs.serviceFactoryDescription': 'Servis factory kalıbı, farklı servis uygulamaları arasında kolay geçiş yapılmasını sağlar:',
  'docs.switchingBackends': 'Backend Değiştirme',
  'docs.switchingBackendsDescription': 'Farklı backend uygulamaları arasında geçiş yapmak için setServiceImplementation fonksiyonunu çağırın:',
  'docs.backendImplementation': 'Backend Uygulaması',
  'docs.backendImplementationDescription': 'Backend, GraphQL API sağlamak için pg_graphql uzantısıyla Supabase kullanır:',
  'docs.pgGraphql': 'pg_graphql Uzantısı',
  'docs.pgGraphqlDescription': 'pg_graphql uzantısı, veritabanı şemanızdan otomatik olarak bir GraphQL API oluşturur:',
  'docs.alternativeBackends': 'Alternatif Backend\'ler',
  'docs.alternativeBackendsDescription': 'Alternatif backend\'ler uygulamak için, servis factory\'de tanımlanan servis arayüzlerine uygun yeni servis uygulamaları oluşturun.',

  // Error translations
  'error.defaultTitle': 'Bir hata oluştu',
  'error.defaultMessage': ' ', 
  'error.profileInvalidTitle': 'Bir hata oluştu',
  'error.profileInvalidMessage': 'Kullanıcı profili geçersiz',
  'error.goHome': 'Ana Sayfaya Git',
  'error.contactSupport': 'Destek ile İletişime Geç',
};

const calendar = {
  'calendar.january': 'Ocak',
  'calendar.february': 'Şubat',
  'calendar.march': 'Mart',
  'calendar.april': 'Nisan',
  'calendar.may': 'Mayıs',
  'calendar.june': 'Haziran',
  'calendar.july': 'Temmuz',
  'calendar.august': 'Ağustos',
  'calendar.september': 'Eylül',
  'calendar.october': 'Ekim',
  'calendar.november': 'Kasım',
  'calendar.december': 'Aralık',
  'calendar.months.january': 'Oca',
  'calendar.months.february': 'Şub',
  'calendar.months.march': 'Mar',
  'calendar.months.april': 'Nis',
  'calendar.months.may': 'May',
  'calendar.months.june': 'Haz',
  'calendar.months.july': 'Tem',
  'calendar.months.august': 'Ağu',
  'calendar.months.september': 'Eyl',
  'calendar.months.october': 'Eki',
  'calendar.months.november': 'Kas',
  'calendar.months.december': 'Ara',
  'calendar.weekdays.monday': 'Pt',
  'calendar.weekdays.tuesday': 'Sa',
  'calendar.weekdays.wednesday': 'Ça',
  'calendar.weekdays.thursday': 'Pe',
  'calendar.weekdays.friday': 'Cu',
  'calendar.weekdays.saturday': 'Ct',
  'calendar.weekdays.sunday': 'Pa',
};

export default {
  ...common,
  ...calendar,
};
